import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'formatTime',
})
export class FormatTimePipe implements PipeTransform {
  transform(value: number, showNegative: boolean = false): string {
    const isNegative = value < 0;
    const absValue = Math.abs(value);

    const days: number = Math.floor(absValue / 3600 / 24);
    const hours: number = Math.floor((absValue / 3600) % 24);
    const minutes: number = Math.floor((absValue % 3600) / 60);
    const seconds: number = Math.floor(absValue - minutes * 60);

    let dayString = '';
    if (days > 0) {
      dayString = (days < 10 ? '0' + days : days) + 'd : ';
    }

    const formatted =
      dayString +
      ('00' + hours).slice(-2) +
      'h : ' +
      ('00' + minutes).slice(-2) +
      'm : ' +
      ('00' + seconds).slice(-2) +
      's';

    if (isNegative && showNegative) {
      return '-' + formatted;
    }

    return formatted;

  }
}
